import React, { createContext, useContext, useEffect, useState } from 'react';

export const SIDEBAR_STORAGE_KEY = 'extracta-dev-sidebar-collapsed';

const DevSidebarContext = createContext({
  collapsed: false,
  toggleCollapsed: () => {},
});

export function clearDevSidebarCollapsed() {
  document.documentElement.classList.remove('dev-sidebar-collapsed');
}

export function initDevSidebarCollapsed() {
  const collapsed = localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true';
  document.documentElement.classList.toggle('dev-sidebar-collapsed', collapsed);
}

export function DevSidebarProvider({ children }) {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem(SIDEBAR_STORAGE_KEY) === 'true';
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dev-sidebar-collapsed', collapsed);
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(collapsed));
  }, [collapsed]);

  const toggleCollapsed = () => {
    setCollapsed((prev) => !prev);
  };

  return (
    <DevSidebarContext.Provider
      value={{
        collapsed,
        toggleCollapsed,
      }}
    >
      {children}
    </DevSidebarContext.Provider>
  );
}

export function useDevSidebar() {
  return useContext(DevSidebarContext);
}
